<template>
  <section class="block w-full py-10 mx-auto max-w-container-ws px-4 md:p-10 lg:p-9">
    <TestimonialsSection />
  </section>
</template>

<style lang="scss" scoped>

</style>